// extracted by mini-css-extract-plugin
export default {"project-card":"ProjectCard_project-card__NSyx5","main-image":"ProjectCard_main-image__Lf-wQ","dark":"ProjectCard_dark__u7NY9","project-title":"ProjectCard_project-title__8ieiX"};